import { SET_EMPOWERING_DATA } from "../actions/empoweringActions";

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const empoweringReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMPOWERING_DATA:
      return { ...state, data: action.payload, status: "success" };
    default:
      return state;
  }
};

export default empoweringReducer;
